<template>
  <div class="pack_selector_container categories gap-10 lg-hide" v-dragscroll>
    <NuxtLinkLocale
      :to="`/${currentGameSlug}`"
      exact-active-class="active"
      class="pack_selector justify-start gap-10"
      v-if="showService"
    >
      <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
        {{ $t("new.services") }}
      </h3>
    </NuxtLinkLocale>

    <div
      class="d-flex-column justify-start lg-col-to-row gap-0"
      v-for="category in categories"
      :key="category"
    >
      <div class="d-flex-column justify-start align-start gap-0">
        <button
          class="d-flex-row flex-1 pack_selector space-between"
          role="button"
          @click="navigateToGamePackPage(category.key)"
          :class="[currentOpenDrop === category.key && 'active']"
        >
          <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
            {{ category.short_title }}
          </h3>
          <div class="d-flex-row justify-end flex-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="plus"
              width="10"
              height="10"
              viewBox="0 0 160 160"
              fill="#9A9A9A"
              :class="[currentOpenDrop === category.key && 'minus']"
            >
              <rect class="vertical-line" x="70" width="20" height="160" />
              <rect class="horizontal-line" y="70" width="160" height="20" />
            </svg>
          </div>
        </button>

        <!-- <NuxtLinkLocale
          class="d-flex-row flex-1 pack_selector justify-start"
          role="button"
          :to="`/${currentGameSlug}/${firstPack(category.key)?.slug}`"
          v-if="!currentGamePackSlug"
        >
          <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
            {{ category.short_title }}
          </h3>
        </NuxtLinkLocale> -->
      </div>

      <ul
        class="mmo_category_list"
        :class="[currentOpenDrop === category.key && 'opened']"
      >
        <li v-for="pack in getPacksByKeys(category.key)" :key="pack.id">
          <NuxtLinkLocale
            :to="`/${currentGameSlug}/${pack.slug}`"
            class="height-36 other dark plain hover full-width justify-start t-light medium-l font-family-2 f-w-500 b-radius-6"
            exact-active-class="active_tab"
          >
            {{ pack.short_title }}
          </NuxtLinkLocale>
        </li>
      </ul>
    </div>

    <TpReviews class="xl-hide" />
  </div>

  <p
    class="t-white font-family-1 title-h5 f-w-600 above-sm-hide"
    style="align-self: flex-start"
  >
    {{ $t("select_service") }}
  </p>
  <div
    class="pack_selector_dropdown d-flex-row above-lg-hide"
    v-click-outside="closeOutside"
  >
    <button
      class="primary dark plain hover active_tab medium height-48 b-radius-6 full-width space-between medium-xl font-family-2 f-w-500"
      :class="[isOpen && 'opened']"
      @click.stop="toggleDrop"
      v-if="activePack"
    >
      {{ activePack }}
      <chev-right />
    </button>

    <transition name="slide-fade-top">
      <div
        class="d-flex-column justify-start align-start packs_list gap-18"
        v-if="isOpen"
      >
        <NuxtLinkLocale
          :to="`/${currentGameSlug}/${pack.slug}`"
          v-for="(pack, index) in otherPacks"
          class="medium-xl font-family-2 t-light routes d-flex-column align-start justify-start"
        >
          {{ pack.short_title }}
          <hr class="horizontal" v-if="index !== otherPacks.length - 1" />
        </NuxtLinkLocale>
      </div>
    </transition>
  </div>

  <TpReviews class="above-sm-hide" />
</template>

<script setup>
import ChevRight from "~/components/icons/ChevRight.vue";
import TpReviews from "~/components/common/sections/boosting/TpReviews.vue";
const currentOpenDrop = ref("");
const router = useRouter();
const route = router.currentRoute;
const localePath = useLocalePath();

const isOpen = ref(false);

const toggleDrop = () => {
  isOpen.value = true;
};

const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const props = defineProps({
  showService: {
    default: true,
  },
});

const { currentGameSlug, currentGamePackSlug } = useGameComposable();

const gameStore = useGameStore();

const getPacksByKeys = (key) => {
  if (categories.value?.length <= 0 || !categories.value) return [];

  const packs = gameStore.getGamePacks?.filter((gp) =>
    gp.short_title.includes(key)
  );
  return packs || [];
};

const { t } = useI18n();

const categories = computed(() => {
  if (currentGameSlug === "call-of-duty-boost") {
    return [
      {
        short_title: t("call-of-duty-boost.categories.second"),
        key: "BO6",
      },
      {
        short_title: t("call-of-duty-boost.categories.third"),
        key: "Zombie",
      },
      {
        short_title: t("call-of-duty-boost.categories.fourth"),
        key: "Warzone",
      },
    ];
  }
  return [];
});

const activePack = computed(() => {
  if (!route.value?.params?.gamePackSlug) {
    return t("new.services");
  }
  const packSlug = route.value.params?.gamePackSlug;
  const activePacks = gameStore.getGamePacks.find(
    (pack) => pack.slug === packSlug
  );
  if (activePacks) {
    return activePacks.short_title;
  }
  return "";
});

const otherPacks = computed(() => {
  if (activePack.value !== t("new.services")) {
    let packs = gameStore.getGamePacks.filter(
      (packs) => packs.short_title !== activePack.value
    );
    packs = [...packs];
    return packs;
  }
  if (activePack.value) {
    return gameStore.getGamePacks.filter(
      (packs) => packs.short_title !== activePack.value
    );
  }

  return gameStore.getGamePacks;
});

const firstPack = (categoryKey) => {
  const packs = getPacksByKeys(categoryKey);
  if (packs[0]?.id) {
    const firstPack = packs[0];
    return firstPack;
  }
  return null;
};

const openCategoryDrop = (categoryKey) => {
  if (currentOpenDrop.value === categoryKey) {
    currentOpenDrop.value = "";
    return;
  }
  currentOpenDrop.value = categoryKey;
};

const navigateToGamePackPage = (categoryKey) => {
  if (currentGamePackSlug) {
    openCategoryDrop(categoryKey);
  } else {
    openCategoryDrop(categoryKey);
  }
};

const handleCategoryDrop = () => {
  currentOpenDrop.value = "";
  if (currentGamePackSlug.includes("zombie")) {
    currentOpenDrop.value = "Zombie";
  } else if (currentGamePackSlug.includes("black-ops-6")) {
    currentOpenDrop.value = "BO6";
  } else if (currentGamePackSlug.includes("warzone")) {
    currentOpenDrop.value = "Warzone";
  }
};

handleCategoryDrop();

onBeforeRouteLeave(() => {
  handleCategoryDrop();
});
</script>

<style lang="scss" scoped>
.mmo_category_list {
  width: 100%;
  max-height: 0px;
  overflow: hidden;
  transition: all 1s ease-in-out;
  list-style: none;
  &.opened {
    margin-top: 10px;
    max-height: 500px;
  }
  li {
    position: relative;
    padding-left: 11px;
    &::before {
      content: "";
      width: 14px;
      height: 100%;
      background-image: url("/images/games/world-of-warcraft-boost/category_list_other.webp");
      position: absolute;
      // top: -5px;
      left: 0;
      background-size: cover;
    }
    &:first-child {
      &::before {
        background-image: url("/images/games/world-of-warcraft-boost/category_list_first.webp");
      }
    }
    &:last-child {
      &::before {
        top: -10px !important;
        background-image: url("/images/games/world-of-warcraft-boost/category_list_last.webp");
      }
    }
    &:not(:first-child) {
      margin-top: 5px;
      &::before {
        top: -5px;
      }
    }
  }
}
</style>
